import img1 from "./assets/img/2 Dogs with Red Bows - Pastel.jpg"
import img2 from "./assets/img/3 Children - Charcoal.jpg"
import img3 from "./assets/img/3 Children in Blue Jeans - Pastel.jpg"
import img4 from "./assets/img/Andy - Pastels.jpg"
import img5 from "./assets/img/Baby - Charcoal and Pastel.jpg"
import img6 from "./assets/img/Baby - Graphite and Pastels.jpg"
import img7 from "./assets/img/Becky-Lou - Pastel.jpg"
import img8 from "./assets/img/Blonde Cutie - Pastel.jpg"
import img9 from "./assets/img/Bulldog - Pastel.jpg"
import img10 from "./assets/img/Chelsea - Pastel.jpg"
import img11 from "./assets/img/Children and Dog - Charcoal.jpg"
import img12 from "./assets/img/Children in Costume - Pastel.jpg"
import img13 from "./assets/img/Collie - Pastel.jpg"
import img14 from "./assets/img/Dog - Pastels.jpg"
import img15 from "./assets/img/Dog with Tulips - Pastel.jpg"
import img16 from "./assets/img/Golden Retriever - Pastel.jpg"
import img17 from "./assets/img/Golden Retriever Head Shot - Pastel.jpg"
import img18 from "./assets/img/Golden Retriever Head Shot - Pastels.jpg"
import img19 from "./assets/img/Grandchildren - Charcoal.jpg"
import img20 from "./assets/img/Grandmother - Charcoal.jpg"
import img21 from "./assets/img/Mr T - Pastels and Charcoal.jpg"
import img22 from "./assets/img/Young Lady - Pastel.jpg"
import img23 from "./assets/img/Frenchie.jpg"
import img24 from "./assets/img/Gizmo.jpg"
import img25 from "./assets/img/Golden.jpg"
import img26 from "./assets/img/Grazing.jpg"
import img27 from "./assets/img/Justice.jpg"
import img28 from "./assets/img/Orchid.jpg"
import img29 from "./assets/img/Spider.jpg"

import thumb1 from "./assets/img/thumbnails/2-Dogs-with-Red-Bows---Pastel.jpg"
import thumb2 from "./assets/img/thumbnails/3-Children---Charcoal.jpg"
import thumb3 from "./assets/img/thumbnails/3-Children-in-Blue-Jeans---Pastel.jpg"
import thumb4 from "./assets/img/thumbnails/Andy---Pastels.jpg"
import thumb5 from "./assets/img/thumbnails/Baby---Charcoal-and-Pastel.jpg"
import thumb6 from "./assets/img/thumbnails/Baby---Graphite-and-Pastels.jpg"
import thumb7 from "./assets/img/thumbnails/Becky-Lou---Pastel.jpg"
import thumb8 from "./assets/img/thumbnails/Blonde-Cutie.jpg"
import thumb9 from "./assets/img/thumbnails/Bulldog---Pastel.jpg"
import thumb10 from "./assets/img/thumbnails/Chelsea---Pastel.jpg"
import thumb11 from "./assets/img/thumbnails/Children-and-Dog---Charcoal.jpg"
import thumb12 from "./assets/img/thumbnails/Children-in-Costume---Pastel.jpg"
import thumb13 from "./assets/img/thumbnails/Collie---Pastel.jpg"
import thumb14 from "./assets/img/thumbnails/Dog---Pastels.jpg"
import thumb15 from "./assets/img/thumbnails/Dog-with-Tulips---Pastel.jpg"
import thumb16 from "./assets/img/thumbnails/Golden-Retriever---Pastel.jpg"
import thumb17 from "./assets/img/thumbnails/Golden-Retriever-Head-Shot---Pastel.jpg"
import thumb18 from "./assets/img/thumbnails/Golden-Retriever-Head-Shot---Pastels.jpg"
import thumb19 from "./assets/img/thumbnails/Grandchildren---Charcoal.jpg"
import thumb20 from "./assets/img/thumbnails/Grandmother---Charcoal.jpg"
import thumb21 from "./assets/img/thumbnails/Mr-T---Pastels-and-Charcoal.jpg"
import thumb22 from "./assets/img/thumbnails/Young-Lady---Pastel.jpg"
import thumb23 from "./assets/img/thumbnails/Frenchie.jpg"
import thumb24 from "./assets/img/thumbnails/Gizmo.jpg"
import thumb25 from "./assets/img/thumbnails/Golden.jpg"
import thumb26 from "./assets/img/thumbnails/Grazing.jpg"
import thumb27 from "./assets/img/thumbnails/Justice.jpg"
import thumb28 from "./assets/img/thumbnails/Orchid.jpg"
import thumb29 from "./assets/img/thumbnails/Spider.jpg"

import bee from "./assets/img/thumbnails/Bee.jpg"
import blue from "./assets/img/thumbnails/Blue.jpg"
import galloping from "./assets/img/thumbnails/GallopingHorse.jpg"
import gorilla from "./assets/img/thumbnails/Gorilla.jpg"
import reagan from "./assets/img/thumbnails/Reagan.jpg"
import sunny from "./assets/img/thumbnails/Sunny.jpg"
import lion from "./assets/img/thumbnails/Lion.jpg"
import tiger from "./assets/img/thumbnails/Tiger.jpg"
import elephant from "./assets/img/thumbnails/Elephant.jpg"
import dogs from "./assets/img/thumbnails/dogs.jpg"

import dog from "./assets/img/dog.jpg"
import cat from "./assets/img/cat.jpg"
import cat2 from "./assets/img/cat2.jpg"

import dog2 from "./assets/img/thumbnails/dog-leaves.jpg"
import dog3 from "./assets/img/thumbnails/scotty-dog.jpg"

import girl from "./assets/img/IMG_2445.jpg"
import twokids from "./assets/img/2 kids.jpg"

export const images = [
    {
        caption: "Two Kids",
        src: twokids,
        thumbnail: twokids,
        thumbnailWidth: 1896,
        thumbnailHeight: 2027,
        tags: []
    },
    {
        caption: "2 Dogs with Red Bows - Pastel",
        src: img1,
        thumbnail: thumb1,
        thumbnailWidth: 400,
        thumbnailHeight: 524,
        tags: []
    },
    {
        caption: "3 Children - Charcoal",
        src: img2,
        thumbnail: thumb2,
        thumbnailWidth: 400,
        thumbnailHeight: 385,
        tags: []
    },
    {
        caption: "3 Children in Blue Jeans - Pastel",
        src: img3,
        thumbnail: thumb3,
        thumbnailWidth: 400,
        thumbnailHeight: 521,
        tags: []
    },
    {
        caption: "Andy - Pastels",
        src: img4,
        thumbnail: thumb4,
        thumbnailWidth: 400,
        thumbnailHeight: 513,
        tags: []
    },
    {
        caption: "Baby - Charcoal and Pastel",
        src: img5,
        thumbnail: thumb5,
        thumbnailWidth: 400,
        thumbnailHeight: 271,
        tags: []
    },
    {
        caption: "Baby - Graphite and Pastels",
        src: img6,
        thumbnail: thumb6,
        thumbnailWidth: 400,
        thumbnailHeight: 343,
        tags: []
    },
    {
        caption: "3 Children - Charcoal",
        src: img7,
        thumbnail: thumb7,
        thumbnailWidth: 400,
        thumbnailHeight: 494,
        tags: []
    },
    {
        caption: "Blonde Cutie - Pastel",
        src: img8,
        thumbnail: thumb8,
        thumbnailWidth: 400,
        thumbnailHeight: 510,
        tags: []
    },
    {
        caption: "Bulldog - Pastel",
        src: img9,
        thumbnail: thumb9,
        thumbnailWidth: 400,
        thumbnailHeight: 463,
        tags: []
    },
    {
        caption: "Chelsea - Pastel",
        src: img10,
        thumbnail: thumb10,
        thumbnailWidth: 400,
        thumbnailHeight: 564,
        tags: []
    },
    {
        caption: "Children and Dog - Charcoal",
        src: img11,
        thumbnail: thumb11,
        thumbnailWidth: 400,
        thumbnailHeight: 325,
        tags: []
    },
    {
        caption: "Children in Costume - Pastel",
        src: img12,
        thumbnail: thumb12,
        thumbnailWidth: 400,
        thumbnailHeight: 401,
        tags: []
    },
    {
        caption: "Collie - Pastel",
        src: img13,
        thumbnail: thumb13,
        thumbnailWidth: 400,
        thumbnailHeight: 321,
        tags: []
    },
    {
        caption: "Dog - Pastels",
        src: img14,
        thumbnail: thumb14,
        thumbnailWidth: 400,
        thumbnailHeight: 509,
        tags: []
    },
    {
        caption: "Dog with Tulips - Pastel",
        src: img15,
        thumbnail: thumb15,
        thumbnailWidth: 400,
        thumbnailHeight: 512,
        tags: []
    },
    {
        caption: "Golden Retriever - Pastel",
        src: img16,
        thumbnail: thumb16,
        thumbnailWidth: 400,
        thumbnailHeight: 272,
        tags: []
    },
    {
        caption: "Golden Retriever Head Shot - Pastel",
        src: img17,
        thumbnail: thumb17,
        thumbnailWidth: 400,
        thumbnailHeight: 525,
        tags: []
    },
    {
        caption: "Golden Retriever Head Shot - Pastels",
        src: img18,
        thumbnail: thumb18,
        thumbnailWidth: 400,
        thumbnailHeight: 540,
        tags: []
    },
    {
        caption: "Grandchildren - Charcoal",
        src: img19,
        thumbnail: thumb19,
        thumbnailWidth: 400,
        thumbnailHeight: 272,
        tags: []
    },
    {
        caption: "Grandmother - Charcoal",
        src: img20,
        thumbnail: thumb20,
        thumbnailWidth: 400,
        thumbnailHeight: 468,
        tags: []
    },
    {
        caption: "Mr T - Pastels and Charcoal",
        src: img21,
        thumbnail: thumb21,
        thumbnailWidth: 400,
        thumbnailHeight: 558,
        tags: []
    },
    {
        caption: "Young Lady - Pastel",
        src: img22,
        thumbnail: thumb22,
        thumbnailWidth: 400,
        thumbnailHeight: 517,
        tags: []
    },
    {
        caption: "Frenchie",
        src: img23,
        thumbnail: thumb23,
        thumbnailWidth: 400,
        thumbnailHeight: 496,
        tags: []
    },
    {
        caption: "Gizmo",
        src: img24,
        thumbnail: thumb24,
        thumbnailWidth: 400,
        thumbnailHeight: 500,
        tags: []
    },
    {
        caption: "Golden",
        src: img25,
        thumbnail: thumb25,
        thumbnailWidth: 400,
        thumbnailHeight: 315,
        tags: []
    },
    {
        caption: "Grazing",
        src: img26,
        thumbnail: thumb26,
        thumbnailWidth: 400,
        thumbnailHeight: 283,
        tags: []
    },
    {
        caption: "Justice",
        src: img27,
        thumbnail: thumb27,
        thumbnailWidth: 400,
        thumbnailHeight: 486,
        tags: []
    },
    {
        caption: "Orchid",
        src: img28,
        thumbnail: thumb28,
        thumbnailWidth: 400,
        thumbnailHeight: 492,
        tags: []
    },
    {
        caption: "Spider",
        src: img29,
        thumbnail: thumb29,
        thumbnailWidth: 400,
        thumbnailHeight: 311,
        tags: []
    },
    {
        caption: "Blue",
        src: blue,
        thumbnail: blue,
        thumbnailWidth: 800,
        thumbnailHeight: 679,
        tags: []
    },
    {
        caption: "Galloping Horse",
        src: galloping,
        thumbnail: galloping,
        thumbnailWidth: 940,
        thumbnailHeight: 737,
        tags: []
    },
    {
        caption: "Gorilla",
        src: gorilla,
        thumbnail: gorilla,
        thumbnailWidth: 887,
        thumbnailHeight: 1112,
        tags: []
    },
    {
        caption: "Bee",
        src: bee,
        thumbnail: bee,
        thumbnailWidth: 640,
        thumbnailHeight: 471,
        tags: []
    },
    {
        caption: "Lion",
        src: lion,
        thumbnail: lion,
        thumbnailWidth: 889,
        thumbnailHeight: 697,
        tags: []
    },
    {
        caption: "Reagan",
        src: reagan,
        thumbnail: reagan,
        thumbnailWidth: 736,
        thumbnailHeight: 910,
        tags: []
    },
    {
        caption: "Elephant",
        src: elephant,
        thumbnail: elephant,
        thumbnailWidth: 865,
        thumbnailHeight: 1099,
        tags: []
    },
    {
        caption: "Sunny",
        src: sunny,
        thumbnail: sunny,
        thumbnailWidth: 716,
        thumbnailHeight: 559,
        tags: []
    },
    {
        caption: "Tiger",
        src: tiger,
        thumbnail: tiger,
        thumbnailWidth: 685,
        thumbnailHeight: 1008,
        tags: []
    },
    {
        caption: "Dogs",
        src: dogs,
        thumbnail: dogs,
        thumbnailWidth: 2859,
        thumbnailHeight: 2014,
        tags: []
    },
    {
        caption: "Cat",
        src: cat,
        thumbnail: cat,
        thumbnailWidth: 800,
        thumbnailHeight: 648,
        tags: []
    },
    {
        caption: "Cat 2",
        src: cat2,
        thumbnail: cat2,
        thumbnailWidth: 663,
        thumbnailHeight: 800,
        tags: []
    },
    {
        caption: "Dog",
        src: dog,
        thumbnail: dog,
        thumbnailWidth: 651,
        thumbnailHeight: 800,
        tags: []
    },
    {
        caption: "Girl",
        src: girl,
        thumbnail: girl,
        thumbnailWidth: 700,
        thumbnailHeight: 811,
        tags: []
    },
    {
        caption: "Dog in leaves",
        src: dog2,
        thumbnail: dog2,
        thumbnailWidth: 651,
        thumbnailHeight: 800,
        tags: []
    },
    {
        caption: "Scotty Dog",
        src: dog3,
        thumbnail: dog3,
        thumbnailWidth: 2063,
        thumbnailHeight: 2650,
        tags: []
    }
];



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/